import React, { useState, useEffect } from 'react';
import { withStyles } from '@mui/styles';
import { WithStyles, StyleRules, ClassNameMap } from '@mui/material/styles/withStyles';
import { Theme } from '@mui/material/styles';
import {  FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, Grid, Typography } from "@mui/material";

const styles = (theme: Theme): StyleRules => ({
  container: {
   
  },
});

interface Props extends React.HTMLProps<HTMLDivElement> {
  history: any;
  match: any;
}


const MFAMethodSelect: React.FC<Props & WithStyles<keyof typeof styles>> = (props) => {
  const { classes }: { classes: ClassNameMap } = props;

  const [authenticatorEnabled, setAuthenticatorEnabled] = useState(false);
  const [emailEnabled, setEmailEnabled] = useState(false);
  const [smsEnabled, setSmsEnabled] = useState(false);
  const [methods, setMethods] = useState([])

  useEffect(() => {

    var {mfaMethodEmailEnabled, mfaMethodAuthenticatorEnabled} = (window as any).App

    var _methods: Array<string> = []
    if (mfaMethodAuthenticatorEnabled) {
      _methods.push("Authenticator")
      setAuthenticatorEnabled(true)
    }

    if (mfaMethodEmailEnabled) {
      _methods.push("Email")
      setEmailEnabled(true)
    }

    setMethods(_methods)

    if (_methods.length == 1) {
      if (props.onChange) {
        props.onChange(_methods[0])
      }
    }
    
  }, [])
  
  const handleMethodSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (props.onChange) {
        props.onChange((event.target as HTMLInputElement).value)
    }
  }

  return (
    <div>
      {methods.length > 1 && <Grid container style={{marginBottom: 25}} spacing={2}> 
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Typography style={{}} variant="subtitle1">
            Please select the method you would like to use. 
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <FormControl>
            <FormLabel>MFA Method</FormLabel>
            <RadioGroup
                row
                value={props.value}
                onChange={handleMethodSelect}
            >
            {authenticatorEnabled && <FormControlLabel value="Authenticator" control={<Radio />} label="Authenticator" />}
            {emailEnabled && <FormControlLabel value="Email" control={<Radio />} label="Email" />}
            {smsEnabled && <FormControlLabel value="Text Message" control={<Radio />} label="Text Message" />}
            </RadioGroup>
        </FormControl>
        </Grid>
      </Grid>}
    </div>
  )
};

export default withStyles(styles)(MFAMethodSelect);